'use client';

import { useState, useEffect } from 'react';
import Icon from '@/components/ui/AppIcon';

interface Metric {
  label: string;
  value: string;
  change: string;
  isPositive: boolean;
  icon: string;
}

interface PerformanceMetricsProps {
  metrics: Metric[];
}

const PerformanceMetrics = ({ metrics }: PerformanceMetricsProps) => {
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  if (!isHydrated) {
    return (
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
        {[1, 2, 3, 4].map((i) => (
          <div key={i} className="bg-card border border-border rounded-lg p-6">
            <div className="animate-pulse">
              <div className="h-10 w-10 bg-muted rounded-full mb-4"></div>
              <div className="h-4 bg-muted rounded w-20 mb-2"></div>
              <div className="h-6 bg-muted rounded w-24"></div>
            </div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
      {metrics.map((metric, index) => (
        <div
          key={index}
          className="bg-card border border-border rounded-lg p-6 hover:scale-105 transition-all duration-200 dark:hover:shadow-cyan-glow"
        >
          <div className="flex items-center justify-between mb-4">
            <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center">
              <Icon name={metric.icon as any} size={24} className="text-primary" variant="solid" />
            </div>
            <div className={`flex items-center space-x-1 text-sm font-semibold ${metric.isPositive ? 'text-success' : 'text-error'}`}>
              <Icon name={metric.isPositive ? 'ArrowTrendingUpIcon' : 'ArrowTrendingDownIcon'} size={16} />
              <span>{metric.change}</span>
            </div>
          </div>
          <p className="text-sm text-muted-foreground mb-2">{metric.label}</p>
          <p className="text-2xl font-heading font-bold text-foreground">{metric.value}</p>
        </div>
      ))}
    </div>
  );
};

export default PerformanceMetrics;